import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Row, Col, Alert } from "components/bootstrap";
import OrientationSelect from "report/report-creation/OrientationSelect";
import FormikSwitch from "report/report-creation/FormikSwitch";
import Separator from "report/report-creation/Separator";
import useReportForm from "report/report-creation/useReportForm";
import { FormikInput, InputDescription } from "components/common";
import ReportLogoEdit from "report/report-creation/content/ReportLogoEdit";
import PageSizeSelect from "./PageSizeSelect";
const ChildOptions = styled.div`
  padding-top: 5px;
`;
const PageNumbers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;

  label {
    font-size: 16px;
  }
`;
const Style = ({ editAllowed }) => {
  const { t } = useTranslation("enterprise_report");
  const {
    values: { layout, hideWidgetDescription }
  } = useReportForm();
  const format = layout == null ? void 0 : layout.format;
  const isPDF = !format || format === "PDF";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isPDF && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("style.pdf_only_warning")), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(PageSizeSelect, { disabled: !isPDF || !editAllowed })), /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(OrientationSelect, { disabled: !isPDF || !editAllowed })), /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printHeader", label: t("style.header"), disabled: !isPDF || !editAllowed }), (layout == null ? void 0 : layout.printHeader) && /* @__PURE__ */ React.createElement(ChildOptions, null, /* @__PURE__ */ React.createElement(InputDescription, { help: t("style.header_help") }), /* @__PURE__ */ React.createElement(ReportLogoEdit, null), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: t("style.header_text"),
      name: "layout.header",
      id: "layout.header",
      type: "textarea",
      help: t("style.header_text_help"),
      maxLength: 330
    }
  )), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printFooter", label: t("style.footer"), disabled: !isPDF || !editAllowed }), (layout == null ? void 0 : layout.printFooter) && /* @__PURE__ */ React.createElement(ChildOptions, null, /* @__PURE__ */ React.createElement(InputDescription, { help: t("style.footer_help") }), /* @__PURE__ */ React.createElement(PageNumbers, null, /* @__PURE__ */ React.createElement(FormikSwitch, { label: t("style.page_numbers"), name: "layout.printPageNumbers" })), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: t("style.footer_text"),
      name: "layout.footer",
      id: "layout.footer",
      type: "textarea",
      maxLength: 330
    }
  )), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(FormikSwitch, { name: "layout.printToc", label: t("style.toc"), disabled: !isPDF || !editAllowed }), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikSwitch,
    {
      name: "hideWidgetDescription",
      label: t("style.hide_widget_description"),
      disabled: !isPDF || !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikSwitch,
    {
      name: "hideWidgetQuery",
      label: t("style.hide_widget_query"),
      disabled: !isPDF || hideWidgetDescription || !editAllowed
    }
  ))));
};
export default Style;
